import { ClaimDisputeStatus } from '../model/departure-claim';
import { ClaimStatus } from '../model/departure-reading';


export function colorizeClaimStatusBackground(status: ClaimStatus): string {
    switch (status) {
        case ClaimStatus.UPHELD:
            return 'sakp-orange-background';
        case ClaimStatus.NEW:
            return 'sakp-red-background';
        case ClaimStatus.INDISPUTABLE:
            return 'sakp-charcoal-background';
        case ClaimStatus.DISPUTED:
            return 'sakp-blue-background';
        case ClaimStatus.RELEASED:
            return 'sakp-green-background';
        default:
            return '';
    }
}

export function colorizeDisputeStatusBackground(status: ClaimDisputeStatus): string {
    switch (status) {
        case ClaimDisputeStatus.DRAFT:
            return 'sakp-purple-background';
        case ClaimDisputeStatus.REJECTED:
            return 'sakp-orange-background';
        case ClaimDisputeStatus.NONE:
            return 'sakp-red-background';
        case ClaimDisputeStatus.INDISPUTABLE:
            return 'sakp-charcoal-background';
        case ClaimDisputeStatus.SUBMITTED:
            return 'sakp-blue-background';
        case ClaimDisputeStatus.APPROVED:
            return 'sakp-green-background';
        default:
            return '';
    }
}

export function colorizeDisputeStatusFont(status: ClaimDisputeStatus): string {
    switch (status) {
        case ClaimDisputeStatus.DRAFT:
            return 'sakp-purple-color';
        case ClaimDisputeStatus.REJECTED:
            return 'sakp-orange-color';
        case ClaimDisputeStatus.NONE:
            return 'sakp-red-color';
        case ClaimDisputeStatus.INDISPUTABLE:
            return 'sakp-charcoal-color';
        case ClaimDisputeStatus.SUBMITTED:
            return 'sakp-blue-color';
        case ClaimDisputeStatus.APPROVED:
            return 'sakp-green-color';
        default:
            return '';
    }
}

export function disputeStatusToSquare(status: ClaimDisputeStatus): string {
    switch (status) {
        case ClaimDisputeStatus.NONE:
            return '🟥';
        case ClaimDisputeStatus.SUBMITTED:
            return '🟦';
        case ClaimDisputeStatus.REJECTED:
            return '🟧';
        case ClaimDisputeStatus.APPROVED:
            return '🟩';
        case ClaimDisputeStatus.INDISPUTABLE:
            return '🟫';
        case ClaimDisputeStatus.DRAFT:
            return '🟪';
        default:
            return '⬜';
    }
}

export function claimStatusToSquare(status: ClaimStatus): string {
    switch (status) {
        case ClaimStatus.NEW:
            return '🟥';
        case ClaimStatus.DISPUTED:
            return '🟦';
        case ClaimStatus.UPHELD:
            return '🟧';
        case ClaimStatus.RELEASED:
            return '🟩';
        case ClaimStatus.INDISPUTABLE:
            return '🟫';
        default:
            return '⬜';
    }
}

